import { ReactNode, useContext, useEffect } from 'react';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { AddNewItemsAction } from '../../../lib/context/SmartSendContextModels';
import { CreateItemRes } from '../../../lib/helpers/useItemCreateHelper';
import { EventSections } from '../../../lib/events/EventLogger';
import useCreateItemsHelper from '../../../lib/helpers/useItemCreateHelper';
import { CsvCore } from '../../smartsend/panels/CsvCore';
import { CsvSmartSendMapResult } from '../../csv/MapCsvDataToSmartSendItem';
import { uid } from '~/apps/smartsend/lib/helpers/uid';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

type props = {
  onComplete?: () => void;
  label?: ReactNode;
};

export default function QuickCsv({ onComplete, label }: props) {
  const { createItemsHelper } = useCreateItemsHelper();
  const ctx = useContext(SmartSendContext);
  const { track } = useSmartSendAnalytics();

  useEffect(() => {
    track({
      type: 'csv_quick_action_loaded',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.CsvUpload])
      }
    });
  }, []);

  async function saveNewItems(items: CsvSmartSendMapResult[], _originalHeaders: string[]): Promise<CreateItemRes[]> {
    const mapped = items.map((x) => {
      return { id: uid(), item: x.item, raw: x.raw };
    });

    const summary = await createItemsHelper(
      mapped,
      (ii) => {
        ctx.dispatch(new AddNewItemsAction(ii));
        onComplete?.();
      },
      () => {},
      () => {}
    );

    if (summary.failed.length === 0) {
      if (summary.messages.length > 0) {
        // TODO
      } else {
        // TODO
      }
    }

    return summary.failed;
  }

  return <CsvCore onSave={saveNewItems} label={label} />;
}
